import { useState, useEffect, useCallback, useRef } from "react";
import { MoveLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { Dropdown, Button, Spinner, ToastContainer, Toast } from "react-bootstrap";
import { getStopsViewApi, getActualWorkflowApi, getEstimateWorkflowApi } from "./stops-api";
import locationIcon from "../../assets/svg/location_ic.svg";
import moreIcon from "../../assets/svg/more_ic.svg";
import { deleteStopsApi } from "./stops-api";
import DeleteModal from "../common/deleteModel";
import dateIc from "../../assets/svg/date_ic.svg";
import TruckProgressBar from "./truck-progress-bar";
import dollerIc from "../../assets/svg/doller_ic.svg";
import workflowTick from "../../assets/svg/workflow-tick.svg";
import activeStop from "../../assets/svg/active-location.svg";
import activeWorkflow from "../../assets/svg/active-workflow.svg";
import workflowIcon from "../../assets/svg/workflow.svg";

import { MapContainer, TileLayer, Marker, Popup, Polyline } from "react-leaflet";
import L from "leaflet";
import polyline from "@mapbox/polyline";
import stopPinImg from "../../assets/png/location-pin.png";
import Sidebar from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import fromLocImg from "../../assets/png/from_location.png";
import toLocImg from "../../assets/png/to_location.png";
import RoadRoute from "../common/RoadRoute";
import { useGlobal } from "../../GlobalContext";
import ProfileImageModal from "../common/ProfileImageModal";
export const StopView = () => {
  const { rolePermissionList, userType } = useGlobal();
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};
  const [viewStopDetails, setViewStopDetails] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("stops");
  const [actualWorkflow, setActualWorkflow] = useState([]);
  const [estimateWorkflow, setEstimateWorkflow] = useState([]);
  const [showProfilePopup, setShowProfilePopup] = useState(false);

  useEffect(() => {
    if (id != null) {
      getStopView(id);
      getActualWorkflow(id);
      getEstimateWorkflow(id);
    }
  }, [id]);
  function checkPermission(permission) {
    return rolePermissionList.findIndex((element) => element["name"] === "Stops" && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }
  const getStopView = async (id) => {
    try {
      const response = await getStopsViewApi(id);

      if (response.data.success === true) {
        setViewStopDetails(response.data.stops ?? {});
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getActualWorkflow = async (id) => {
    try {
      const response = await getActualWorkflowApi(id);

      if (response.data.success === true) {
        setActualWorkflow(response.data.tripHistory ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getEstimateWorkflow = async (id) => {
    try {
      const response = await getEstimateWorkflowApi(id);

      if (response.data.success === true) {
        setEstimateWorkflow(response.data.estimatedworkflow ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  const deleteVendor = async () => {
    // setIsLoading(true);
    try {
      const response = await deleteStopsApi(deleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        navigate(-1);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const createCustomFromMarker = () =>
    L.divIcon({
      className: "custom-icon",
      html: `
          <div style="position: relative; display: inline-block;">
            <!-- Your image from assets -->
            <img src="${fromLocImg}" style="width:40px;height:40px;" />
            
            <!-- Text overlay -->
            <span style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              color: white;
              font-size: 14px;
              font-weight: bold;
            ">
             
            </span>
          </div>
        `,
      iconSize: [40, 40], // size of whole div
      iconAnchor: [20, 40], // bottom center
      popupAnchor: [0, -40],
    });
  const createCustomToMarker = () =>
    L.divIcon({
      className: "custom-icon",
      html: `
          <div style="position: relative; display: inline-block;">
            <!-- Your image from assets -->
            <img src="${toLocImg}" style="width:40px;height:40px;" />
            
            <!-- Text overlay -->
            <span style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              color: white;
              font-size: 14px;
              font-weight: bold;
            ">
             
            </span>
          </div>
        `,
      iconSize: [40, 40], // size of whole div
      iconAnchor: [20, 40], // bottom center
      popupAnchor: [0, -40],
    });
  return (
    <>
      <DeleteModal
        title={"stops"}
        isOpen={isOpenDelete}
        onClose={() => {
          setIsOpenDelete(false); // close modal
          setDeleteId(null); // reset selected ID
        }}
        onDelete={deleteVendor}
      />
      <div className="d-flex ">
        <Sidebar currentfile="Stops" />
        <div className="rounded-4 flex-grow-1  " style={{ width: "calc(100vw - 80px)" }}>
          <Navbar pageTitle="Stops" />
          <div className="p-2 scroll-hidden" style={{ background: "#F5F7FA", height: "calc(100vh - 56px)" }}>
            <div
              className="py-2 bg-white d-flex align-items-center justify-content-between"
              style={{
                borderTopLeftRadius: "16px",
                borderTopRightRadius: "16px",
              }}
            >
              <div className="d-flex align-items-center justify-content-start">
                <div
                  className="ms-2 d-flex align-items-center justify-content-center  rounded-5 bg-white"
                  style={{
                    width: "36px",
                    height: "36px",
                    border: "1px solid #EBEBEB",
                  }}
                >
                  <MoveLeft
                    className="cursor-pointer"
                    onClick={() => {
                      navigate(-1);
                    }}
                  />
                </div>

                <div
                  className="ms-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "16px",
                    background: "#DFE8FF",
                    color: "#3469E7",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (viewStopDetails.profile) {
                      setShowProfilePopup(true);
                    }
                  }}
                >
                  <img src={viewStopDetails.profile} alt="profile" style={{ width: "64px", height: "64px" }} />
                  {/* <div className="fs-22 fw-500">
                    {viewStopDetails.customer_name?.charAt(0) ?? "C"}
                  </div> */}
                </div>
                <div className="ms-2 d-flex flex-column align-items-start justify-content-center gap-1">
                  <div className="fs-20 fw-600 textFontColor">{viewStopDetails.customer_name ?? ""}</div>
                  <div className="d-flex align-items-center justify-content-start">
                    <img src={locationIcon} alt="location" />
                    <span className="ms-2 fs-13 fw-400 " style={{ color: "#A2A7AE" }}>
                      {viewStopDetails.location ?? ""}
                    </span>
                    <div
                      className="mx-2"
                      style={{
                        width: "5px",
                        height: "5px",
                        borderRadius: "100px",
                        background: "#D9D9D9",
                      }}
                    ></div>
                    <div className="d-flex align-items-center justify-content-center rounded-4 px-2 py-1" style={{ background: "#EDF2FF", color: "#3469E7" }}>
                      <span className="fs-12 fw-500">#{viewStopDetails.customer_code ?? ""}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-start me-2">
                <Dropdown>
                  <Dropdown.Toggle
                    bsPrefix="custom-toggle"
                    variant="light"
                    id="dropdown-sort"
                    className="d-flex align-items-center justify-content-between backgroundLightOrange rounded-5"
                    style={{
                      padding: "10px 12px",
                    }}
                  >
                    <span className="d-flex align-items-center px-1 gap-2">
                      <span
                        className="backgroundYellow"
                        style={{
                          width: "10px",
                          height: "10px",
                          borderRadius: "3px",
                          display: "inline-block",
                        }}
                      ></span>

                      <span className="dropdown-text textcolor fs-13 fw-500">{viewStopDetails.status ?? "-"}</span>

                      {/* <span className="dropdown-toggle-arrow"></span> */}
                    </span>
                  </Dropdown.Toggle>
                </Dropdown>

                <div className="ms-2">
                  {(checkPermission("edit_permission") || checkPermission("delete_permission")) && viewStopDetails.status === "Created" && (
                    <Dropdown>
                      <Dropdown.Toggle
                        bsPrefix="custom-toggle"
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between  rounded-5 bg-white"
                        style={{
                          width: "36px",
                          height: "36px",
                          border: "1px solid #EBEBEB",
                        }}
                      >
                        <span className="d-flex align-items-center px-1 gap-2">
                          <img src={moreIcon} alt="more" />
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {checkPermission("edit_permission") && viewStopDetails.status === "Created" && (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            onClick={() => {
                              navigate("/stops/create", {
                                state: { id: viewStopDetails.id },
                              });
                            }}
                          >
                            Edit
                          </Dropdown.Item>
                        )}
                        {checkPermission("delete_permission") && viewStopDetails.status === "Created" && (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            onClick={() => {
                              setDeleteId(viewStopDetails.id);
                            }}
                          >
                            Delete
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                </div>
              </div>
            </div>
            <div className="w-100 mb-1  d-flex align-items-center justify-content-start" style={{ background: "#EBF3FF" }}>
              <div
                className={`cursor-pointer d-flex align-items-center justify-content-center  px-2 fs-13  ${selectedTab === "stops" ? "fw-500 active-bottom-bar " : " fw-400"} `}
                style={{
                  height: "40px",
                  minWidth: "110px",
                  color: selectedTab === "stops" ? "#3469E7" : "#5F5E5B",
                }}
                onClick={() => {
                  setSelectedTab("stops");
                }}
              >
                <img src={selectedTab === "stops" ? activeStop : locationIcon} alt="tab" className="me-1" /> Stop details
              </div>
              <div
                className={`cursor-pointer d-flex align-items-center justify-content-center  px-2 fs-13  ${selectedTab === "workflow" ? "fw-500 active-bottom-bar " : " fw-400"} `}
                style={{
                  height: "40px",
                  minWidth: "110px",
                  color: selectedTab === "workflow" ? "#3469E7" : "#5F5E5B",
                }}
                onClick={() => {
                  setSelectedTab("workflow");
                }}
              >
                <img src={selectedTab === "workflow" ? activeWorkflow : workflowIcon} alt="tab" className="me-1" /> Workflow
              </div>
            </div>
            {selectedTab === "stops" && (
              <>
                <div className="row">
                  <div className="col-12 col-lg-5 mt-2">
                    <div className="bg-white rounded-4 p-3 d-flex flex-column align-items-start justify-content-start">
                      <div className="fs-16 fw-600 textFontColor">Stop information</div>

                      <div className="mt-3 d-flex align-items-center justify-content-start">
                        <div style={{ width: "200px" }} className="d-flex align-items-center justify-content-start">
                          <img src={locationIcon} alt="location" />
                          <span className="ms-2 fs-13 fw-500 cardTextGrey">Stop ID</span>
                        </div>
                        <div className="fs-13 fw-500 textFontColor">{viewStopDetails.stop_code ?? ""}</div>
                      </div>

                      <div className="mt-3 d-flex align-items-center justify-content-start">
                        <div style={{ width: "200px" }} className="d-flex align-items-center justify-content-start">
                          <img src={dateIc} alt="date" />
                          <span className="ms-2 fs-13 fw-500 cardTextGrey">Actual delivery date</span>
                        </div>
                        <div className="fs-13 fw-500 textFontColor">{viewStopDetails.act_delivery_date ?? ""}</div>
                      </div>

                      <div className="mt-3 d-flex align-items-center justify-content-start">
                        <div style={{ width: "200px" }} className="d-flex align-items-center justify-content-start">
                          <img src={dateIc} alt="date" />
                          <span className="ms-2 fs-13 fw-500 cardTextGrey">Estimated Delivery Date</span>
                        </div>
                        <div className="fs-13 fw-500 textFontColor">{viewStopDetails.est_delivery_date ?? ""}</div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-lg-7 mt-2">
                    <div className="bg-white rounded-4 p-3 d-flex flex-column align-items-start justify-content-start">
                      <div className="fs-16 fw-600 textFontColor">Address information</div>
                      <div className="mt-2 w-100">
                        <TruckProgressBar progress={50} />
                      </div>
                      <div className="w-100 mt-2 me-2 d-flex align-items-center justify-content-between">
                        <div className="d-flex flex-column align-items-start justify-content-start">
                          <div className="fs-11 fw-700 cardTextGrey">FROM </div>
                          <div className="mt-1 fs-13 fw-7300 textFontColor d-flex flex-wrap justify-content-start">{viewStopDetails.fromaddress} </div>
                        </div>

                        <div className="ms-2 d-flex flex-column align-items-end justify-content-start">
                          <div className="fs-11 fw-700 cardTextGrey">TO </div>
                          <div className="mt-1 fs-13 fw-7300 textFontColor d-flex flex-wrap justify-content-start">{viewStopDetails.toaddress} </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="m-2 bg-white rounded-4 p-3">
                  <div className="row">
                    <div className="col-12 ">
                      <div className="row">
                        <div className="col-xl-12 d-flex justify-content-between">
                          <p className="fs-18 fw-600 mb-0">Product </p>
                          <div className="rounded-4 d-flex justify-content-start p-2" style={{ background: "#FFF7E4" }}>
                            <img src={dollerIc} alt="doller" />
                            <span className="ms-2 fs-13 fw-400 cardTextGrey">Total :</span> <span className="ms-2 fs-14 fw-500 textFontColor">₹ {viewStopDetails.total_amount}</span>
                          </div>
                        </div>
                        <div style={{ overflowY: "visible" }}>
                          <div className="mt-2 sticky-table-wrapper ">
                            <table
                              className="stop-table"
                              border="1"
                              cellPadding="10"
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                                border: "1px solid #EBEBEB",
                              }}
                            >
                              <thead
                                style={{
                                  height: "36px",
                                  backgroundColor: "#F8F8F8", // ✅ Green background
                                  color: "#8790A1", // ✅ White text
                                  fontSize: "11px", // ✅ Font size
                                  fontWeight: "400",
                                  textAlign: "left",
                                }}
                              >
                                <tr>
                                  <th className="ps-2">PRODUCT NAME</th>
                                  <th className="ps-2">WEIGHT</th>
                                  <th className="ps-2">VOLUME</th>
                                  <th className="ps-2">UNIT</th>
                                  <th className="ps-2">QUANTITY</th>
                                  <th className="ps-2">PRICE</th>
                                </tr>
                              </thead>
                              <tbody>
                                {viewStopDetails?.product?.map((row, index) => (
                                  <tr
                                    key={row.id}
                                    style={{
                                      height: "36px",
                                      position: "relative",
                                      overflow: "visible",
                                    }}
                                  >
                                    <td
                                      className="px-2 py-1"
                                      style={{
                                        position: "relative",
                                        overflow: "visible",
                                      }}
                                    >
                                      <div className="pe-3 py-1">{row.item}</div>
                                    </td>
                                    <td className="px-2 py-1">{row.weight}</td>

                                    <td className="px-2 py-1">{row.voulme}</td>

                                    <td className="px-2 py-1" style={{ width: "150px" }}>
                                      {row.unit}
                                    </td>
                                    <td className="px-2 py-1">{row.quantity}</td>
                                    <td className="px-2 py-1">{row.price}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="m-2 bg-white rounded-4 p-3">
                  <div className="row">
                    <div className="col-12 ">
                      <div className="row">
                        <div className="col-xl-12 d-flex justify-content-start">
                          <p className="fs-18 fw-600 mb-0">Route for this stop </p>
                        </div>
                      </div>

                      <div className="w-100 mt-2">
                        <MapContainer center={[30, 0]} zoom={2} style={{ height: "355px", width: "100%" }}>
                          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' />
                          {viewStopDetails.from_latitude !== null && viewStopDetails.from_latitude !== undefined && viewStopDetails.from_longitude !== null && viewStopDetails.from_longitude !== undefined && viewStopDetails.from_latitude !== "" && viewStopDetails.from_longitude !== "" && (
                            <Marker key={`FromLocation`} position={[viewStopDetails.from_latitude, viewStopDetails.from_longitude]} icon={createCustomFromMarker()}>
                              {viewStopDetails.fromaddress !== "" && (
                                <Popup>
                                  <div
                                    style={{
                                      width: 320,
                                      background: "white",
                                      padding: 12,
                                      borderRadius: 12,
                                      boxShadow: "0 6px 18px rgba(14,30,37,0.08)",
                                    }}
                                  >
                                    {viewStopDetails.fromaddress ?? ""}
                                  </div>
                                </Popup>
                              )}
                            </Marker>
                          )}

                          {viewStopDetails.to_latitude !== null && viewStopDetails.to_latitude !== undefined && viewStopDetails.to_longitude !== null && viewStopDetails.to_longitude !== undefined && viewStopDetails.to_latitude !== "" && viewStopDetails.to_longitude !== "" && (
                            <Marker key={`ToLocation`} position={[viewStopDetails.to_latitude, viewStopDetails.to_longitude]} icon={createCustomToMarker()}>
                              {viewStopDetails.toaddress && (
                                <Popup>
                                  <div
                                    style={{
                                      width: 320,
                                      background: "white",
                                      padding: 12,
                                      borderRadius: 12,
                                      boxShadow: "0 6px 18px rgba(14,30,37,0.08)",
                                    }}
                                  >
                                    {viewStopDetails.toaddress ?? ""}
                                  </div>
                                </Popup>
                              )}
                            </Marker>
                          )}
                          {viewStopDetails.map_route &&
                            (() => {
                              const points = viewStopDetails.map_route.split("-").map((point) => {
                                const [lat, lng] = point.split(",");
                                return [parseFloat(lat), parseFloat(lng)];
                              });
                              if (points.length >= 2) {
                                return <RoadRoute from={points[0]} to={points[1]} />;
                              }
                              return null;
                            })()}
                        </MapContainer>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {selectedTab === "workflow" && (
              <div className="w-100 m-2 bg-white rounded-4 p-3">
                <div className="row">
                  <div className="col-12 ">
                    <div className="row">
                      <div className="col-xl-12 d-flex justify-content-start">
                        <p className="fs-18 fw-600 mb-0">Workflow details </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-lg-4">
                        <div>
                          <div className="mx-4 mb-3 mt-2 d-flex align-items-center justify-content-center rounded-3 px-2 py-2 fs-13 fw-600" style={{ background: "#F8F8F8", color: "#5F5E5B" }}>
                            ESTIMATED WORKFLOW
                          </div>
                          {estimateWorkflow.map((row, index) => (
                            <div className="w-100 d-flex justify-content-start ">
                              <div className="d-flex flex-column align-items-center" style={{ height: "auto" }}>
                                <img src={workflowTick} alt="tick" />
                                {index !== estimateWorkflow.length - 1 && (
                                  <div
                                    style={{
                                      borderLeft: "2px dotted #aaa",
                                      height: "100%",
                                      /*  position: "absolute",
                        left: "50%",
                        top: 0, */
                                    }}
                                  ></div>
                                )}
                              </div>

                              <div className="mt-0 ms-3 mb-3">
                                <div className="d-flex align-items-center justify-content-start">
                                  <span className="fs-14 fw-700 " style={{ color: "#2C8C53" }}>
                                    {row.status}
                                  </span>
                                  <div
                                    className="mx-2"
                                    style={{
                                      width: "5px",
                                      height: "5px",
                                      borderRadius: "100px",
                                      background: "#D9D9D9",
                                    }}
                                  ></div>
                                  <div
                                    className="d-flex align-items-center justify-content-center rounded-4 px-2 py-1"
                                    style={{
                                      background: "#EDF2FF",
                                      color: "#3469E7",
                                    }}
                                  >
                                    <span className="ms-2 fs-11 fw-400" style={{ color: "#5F5E5B" }}>
                                      Stop :
                                    </span>
                                    <span className="ms-2 fs-12 fw-500">#{row.stop_id}</span>
                                  </div>
                                </div>

                                {/* <div className="mt-2 fs-13 fw-400 textFontColor d-flex justify-content-start">
                                  Completed this stop without any issue.
                                </div> */}
                                <div className="mt-1 fs-12 fw-400 cardTextGrey d-flex justify-content-start">{row.to_char}</div>
                                {/*  <div className="mt-2 d-flex align-items-center justify-content-start">
                                  <div
                                    className="d-flex align-items-center justify-content-center rounded-4 px-2 py-1 fs-11 fw-400"
                                    style={{
                                      background: "#F8F8F8",
                                      color: "#5F5E5B",
                                    }}
                                  >
                                    View attachments (8)
                                  </div>

                                  <div
                                    className="ms-2 d-flex align-items-center justify-content-center rounded-4 px-2 py-1 fs-11 fw-400"
                                    style={{
                                      background: "#F8F8F8",
                                      color: "#5F5E5B",
                                    }}
                                  >
                                    Update
                                  </div>
                                </div> */}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div
                        className="d-none d-lg-block mt-5"
                        style={{
                          borderLeft: "2px solid #EBEBEB",
                          height: "auto",
                          width: "auto",
                        }}
                      ></div>
                      <div className="col-12 col-lg-4">
                        <div>
                          <div className="mx-4 mb-3 mt-2 d-flex align-items-center justify-content-center rounded-3 px-2 py-2 fs-13 fw-600" style={{ background: "#F8F8F8", color: "#5F5E5B" }}>
                            ACTUAL WORKFLOW
                          </div>
                          {actualWorkflow.map((row, index) => (
                            <div className="w-100 d-flex justify-content-start ">
                              <div className="d-flex flex-column align-items-center" style={{ height: "auto" }}>
                                <img src={workflowTick} alt="tick" />
                                {index !== actualWorkflow.length - 1 && (
                                  <div
                                    style={{
                                      borderLeft: "2px dotted #aaa",
                                      height: "100%",
                                      /*  position: "absolute",
                        left: "50%",
                        top: 0, */
                                    }}
                                  ></div>
                                )}
                              </div>

                              <div className="mt-0 ms-3 mb-3">
                                <div className="d-flex align-items-center justify-content-start">
                                  <span className="fs-14 fw-700 " style={{ color: "#2C8C53" }}>
                                    {row.status}
                                  </span>
                                </div>

                                <div className="mt-2 fs-13 fw-400 textFontColor d-flex justify-content-start">{row.comments ?? ""}</div>
                                <div className="mt-1 fs-12 fw-400 cardTextGrey d-flex justify-content-start">{row.to_char ?? ""}</div>
                                <div className="mt-2 d-flex align-items-center justify-content-start">
                                  <div
                                    className="d-flex align-items-center justify-content-center rounded-4 px-2 py-1 fs-11 fw-400"
                                    style={{
                                      background: "#F8F8F8",
                                      color: "#5F5E5B",
                                    }}
                                  >
                                    View attachments ({row.attachmentscount ?? "0"})
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Profile Image Modal */}
      <ProfileImageModal show={showProfilePopup} onClose={() => setShowProfilePopup(false)} imageUrl={viewStopDetails.profile || ""} />
    </>
  );
};
